import React, { useState, useEffect } from 'react';
import { Menu, X, Phone, MapPin } from 'lucide-react';
import { restaurantInfo, branches } from '../data/mock';

const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navLinks = [
    { name: 'Ana Sayfa', href: '#hero' },
    { name: 'Menü', href: '#menu' },
    { name: 'Hakkımızda', href: '#about' },
    { name: 'Şubelerimiz', href: '#locations' },
    { name: 'İletişim', href: '#contact' }
  ];

  const scrollToSection = (href) => {
    const element = document.querySelector(href);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
    setIsMobileMenuOpen(false);
  };

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        isScrolled
          ? 'bg-stone-950/95 backdrop-blur-md shadow-xl'
          : 'bg-transparent'
      }`}
    >
      {/* Top Bar */}
      <div className={`transition-all duration-300 overflow-hidden ${
        isScrolled ? 'max-h-0 opacity-0' : 'max-h-12 opacity-100'
      }`}>
        <div className="bg-amber-900/80 py-2">
          <div className="container mx-auto px-4 flex justify-between items-center text-amber-100 text-sm">
            <div className="flex items-center gap-2">
              <Phone className="w-4 h-4" />
              <a href={`tel:${branches[0].phone}`} className="hover:text-amber-300 transition-colors">
                {branches[0].phone}
              </a>
            </div>
            <div className="hidden md:flex items-center gap-2">
              <MapPin className="w-4 h-4" />
              <span>Balıkesir - 2 Şube</span>
            </div>
          </div>
        </div>
      </div>

      {/* Main Navigation */}
      <nav className="container mx-auto px-4">
        <div className="flex items-center justify-between h-20">
          {/* Logo */}
          <a
            href="#hero"
            onClick={(e) => {
              e.preventDefault();
              scrollToSection('#hero');
            }}
            className="flex flex-col items-start"
          >
            <span className="font-serif text-2xl md:text-3xl font-bold text-amber-100 tracking-wide">
              Köfteci Sadullah
            </span>
            <span className="text-amber-500/80 text-xs tracking-[0.3em] uppercase">
              {restaurantInfo.since}'den beri
            </span>
          </a>

          {/* Desktop Navigation */}
          <div className="hidden lg:flex items-center gap-8">
            {navLinks.map((link) => (
              <a
                key={link.name}
                href={link.href}
                onClick={(e) => {
                  e.preventDefault();
                  scrollToSection(link.href);
                }}
                className="text-amber-100/90 hover:text-amber-400 transition-colors duration-300 text-sm uppercase tracking-wider font-medium"
              >
                {link.name}
              </a>
            ))}
          </div>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className="lg:hidden p-2 text-amber-100 hover:text-amber-400 transition-colors"
            aria-label="Menu"
          >
            {isMobileMenuOpen ? (
              <X className="w-7 h-7" />
            ) : (
              <Menu className="w-7 h-7" />
            )}
          </button>
        </div>
      </nav>

      {/* Mobile Menu */}
      <div
        className={`lg:hidden absolute top-full left-0 right-0 bg-stone-950/98 backdrop-blur-lg transition-all duration-300 overflow-hidden ${
          isMobileMenuOpen ? 'max-h-96 border-b border-amber-900/30' : 'max-h-0'
        }`}
      >
        <div className="container mx-auto px-4 py-6">
          {navLinks.map((link) => (
            <a
              key={link.name}
              href={link.href}
              onClick={(e) => {
                e.preventDefault();
                scrollToSection(link.href);
              }}
              className="block py-3 text-amber-100/90 hover:text-amber-400 transition-colors duration-300 text-lg border-b border-amber-900/20 last:border-0"
            >
              {link.name}
            </a>
          ))}
          <div className="mt-4 pt-4 border-t border-amber-900/30">
            <a
              href={`tel:${branches[0].phone}`}
              className="flex items-center gap-3 text-amber-400 hover:text-amber-300 transition-colors"
            >
              <Phone className="w-5 h-5" />
              <span>{branches[0].phone}</span>
            </a>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;